import * as React from 'react'

function SvgIe(props) {
	return (
		<svg viewBox="0 0 600 300" width="1em" height="1em" {...props}>
			<path fill="#169b62" d="M0 0h200v300H0z" />
			<path fill="#fff" d="M200 0h200v300H200z" />
			<path fill="#ff883e" d="M400 0h200v300H400z" />
		</svg>
	)
}

export default SvgIe
